module.exports = __webpack_public_path__ + "img/arrow-down-solid.3e9c517e.svg";